import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as pdfMake from "pdfmake/build/pdfmake";
import { takeUntil } from 'rxjs/operators';
import { bloquearSiProcedimientoNoActivo } from 'src/app/_helpers/procedimiento-activo.util';
import { UnsubscribeOnDestroy } from 'src/app/_helpers/unsubscribe-on-destroy';
import { ProcedimientosService } from "src/app/_services/procedimientos.service";
import { SolicitudEmvsService } from "src/app/_services/solicitud-emvs.service";
import { TokenStorageService } from "src/app/_services/token-storage.service";
import { UserService } from "src/app/_services/user.service";
import { environment } from "src/environments/environment";
import { ClaveService } from "../_services/clave.service";
import { PdfgenerateJustificanteNotificaService } from "../_services/pdfgenerateJustificanteNotificaService/pdfgenerate-justificante-notifica.service";
import { ServicioGeneral } from "../_services/servicio-general.service";
import { SolicituCustomService } from "../_services/solicitud-custom.service";
import { NotificationI18nService } from "../core/util/notification-i18n.service";
import { ListadoTramitesEmvsService } from "../listado/listado-tramites-emvs/listado-tramites-emvs.service";
import {
  EstadoTramite,
  TramiteEmvs
} from "../listado/listado-tramites-emvs/tramite-emvs";
import { NotificaDetalles } from "../model/notificadetalles";
import { Destinatario } from "../model/notificaresumen";

@Component({
  selector: "firma-clave",
  templateUrl: "./firma-clave.component.html",
  styleUrls: ["./firma-clave.component.css"],
})
export class FirmaClaveComponent extends UnsubscribeOnDestroy implements OnInit {
  user: any = this._servicioUsuario.getCurrentUserFromServer();
  municipioNombre: string = "";
  submitted: boolean = false;
  isLogged: boolean = false;
  currentEnv = environment.environment;
  tramite: TramiteEmvs = {
    id: -1,
  };
  mensajeSpinner: string = "";
  procedimiento: any = {};

  constructor(
    private tokenStorageService: TokenStorageService,
    private _servicioUsuario: UserService,
    private _notificationI18n: NotificationI18nService,
    private _solicitudEmvsService: SolicitudEmvsService,
    private _router: Router,
    private _serviceProcedimientos: ProcedimientosService,
    private _route: ActivatedRoute,
    private listadoTramitesService: ListadoTramitesEmvsService,
    private spinner: NgxSpinnerService,
    private _claveService: ClaveService,
    private servicioGeneral: ServicioGeneral,
    private pdfJustificante: PdfgenerateJustificanteNotificaService,
    private _solicituCustomService: SolicituCustomService,
    private _download: ListadoTramitesEmvsService
  ) {
    super();
  }

  ngOnInit(): void {
    this.isLogged = !!this.tokenStorageService.getToken();

    if (!this.isLogged) {
      this._router.navigate(["/login"]);
    }
    this._route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        const rId = params["rId"];
        const accion = params["a"];
        const tramite = params["t"];
        if (rId && accion && tramite) {
          this.pdfProcedimientoClave(rId, accion, tramite);
        } else {
          if (accion == "nofirmar") {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_VALIDANDO_LOGIN_CLAVE', 5000);
            setTimeout(() => {
              this._router.navigate(["/perfil"]);
            }, 3000);
          }
        }
      });
  }

  private firmaProcedimiento(rId: string, idTramite: any) {
    let tramite: TramiteEmvs = {
      id: +this.tramite.id,
      estadoFirma: EstadoTramite.FIRMADO_CON_REGISTRO,
      estado: true,
      procedimiento_id: { id: this.procedimiento.id },
      firmarClave: true,
    };

    this._solicitudEmvsService.updateEstadoTramite(tramite)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {


          if (data.estadoFirma == 'FIRMADO_CON_REGISTRO') {
            this.downloadPdf(data.pdfFirmado, "comprobante_solicitud_tramite");
            this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_CON_EXITO', 5000);
          }
          else if (data.estadoFirma == 'PENDIENTE_DE_FIRMA_AUTORIZADOS') {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_PENDIENTE_AUTORIZADOS', 5000);
          }
          else if (data.estadoFirma == 'PROCESANDO') {
            this.downloadPdf(data.pdfFirmado, "comprobante_solicitud_tramite");
            this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_PROCESANDO_CON_EXITO', 5000);
          }
          else {
            if (this.procedimiento?.id && this.procedimiento.id != 2)
              this.downloadPdf(data.pdfFirmado, "comprobante_solicitud_tramite");
            this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_ACTUALIZANDO_ESTADO_TRAMITE_PANEL', 5000);
          }
          this._router.navigate(["/perfil"], {
            queryParams: { action: 30 },
          });

          this.ocultarSpinner();
        },
        error: (error) => {
          this.ocultarSpinner();
          if (error && error.error && error.error.responseError) {
            this._notificationI18n.errorDynamic(error.error, 5000);
          }
          else {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_ACTUALIZANDO_ESTADO_TRAMITE_PANEL', 5000);
          }
          this._router.navigate(["/perfil"], {
            queryParams: { action: 30 },
          });
        },
      });
  }

  public pdfProcedimientoClave(rId: string, accion: string, idTramite: any) {
    if (accion == "firmar") {
      this.mostrarSpinnerMsg("Firmando y registrando el trámite...");

      this.listadoTramitesService.getTramiteById(idTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data) => {
            this.tramite = data;
            this._serviceProcedimientos
              .getProcedimientoByIdTramite(this.tramite.id)

              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (procedimiento) => {
                  if (bloquearSiProcedimientoNoActivo(procedimiento, this._router, this._notificationI18n, this.tokenStorageService.getUser())) {
                    this.ocultarSpinner();
                    return;
                  }
                  this.procedimiento = procedimiento["Procedimiento"];
                  this._claveService.getResultFirma(rId)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                      next: (data: any) => {
                        if (data.status && data.status == "658") {
                          if (!this.procedimiento.custom) {
                            this.firmaProcedimiento(rId, idTramite);
                          } else {
                            this.firmaProcedimientoCustom(rId, idTramite);
                          }
                        } else {
                          this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_VALIDANDO_LOGIN_CLAVE', 5000);
                          this.ocultarSpinner();
                          this._router.navigate(["/perfil"], {
                            queryParams: { action: 30 },
                          });
                        }
                      },
                      error: (error) => {
                        this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_VALIDANDO_LOGIN_CLAVE', 5000);
                        this.ocultarSpinner();
                        this._router.navigate(["/perfil"], {
                          queryParams: { action: 30 },
                        });
                      },
                    });
                },
                error: (error) => {
                  this._notificationI18n.warning('NOTIFICATION.MESSAGE.ERROR_RECOVERY_PROCEDIMIENTO', 5000);
                  this.ocultarSpinner();
                  this._router.navigate(["/perfil"], {
                    queryParams: { action: 30 },
                  });
                },
              });
          },
          error: (error) => {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_RECOVERY_TRAMITE', 5000);
            this.ocultarSpinner();
            this._router.navigate(["/perfil"], {
              queryParams: { action: 30 },
            });
          },
        });
    } else if (accion == "firmar_delete_tramite"
      || accion == "firmar_delete_tramite_by_register"
    ) {
      this.mostrarSpinnerMsg("Firmando y eliminando el trámite...");

      this.listadoTramitesService.getTramiteById(idTramite)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (data) => {
            this.tramite = data;
            this._serviceProcedimientos
              .getProcedimientoByIdTramite(this.tramite.id)

              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (procedimiento) => {
                  if (bloquearSiProcedimientoNoActivo(procedimiento, this._router, this._notificationI18n, this.tokenStorageService.getUser())) {
                    this.ocultarSpinner();
                    return;
                  }
                  this.procedimiento = procedimiento["Procedimiento"];
                  this._claveService.getResultFirma(rId)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                      next: (data: any) => {
                        if (data.status && data.status == "658") {
                          this.deleteProcedimiento(rId, idTramite);
                        } else {
                          this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_VALIDANDO_LOGIN_CLAVE', 5000);
                          this.ocultarSpinner();
                          this._router.navigate(["/perfil"], {
                            queryParams: { action: 30 },
                          });
                        }
                      },
                      error: (error) => {
                        this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_VALIDANDO_LOGIN_CLAVE', 5000);
                        this.ocultarSpinner();
                        this._router.navigate(["/perfil"], {
                          queryParams: { action: 30 },
                        });
                      },
                    });
                },
                error: (error) => {
                  this._notificationI18n.warning('NOTIFICATION.MESSAGE.ERROR_RECOVERY_PROCEDIMIENTO', 5000);
                  this.ocultarSpinner();
                  this._router.navigate(["/perfil"], {
                    queryParams: { action: 30 },
                  });
                },
              });
          },
          error: (error) => {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_RECOVERY_TRAMITE', 5000);
            this.ocultarSpinner();
            this._router.navigate(["/perfil"], {
              queryParams: { action: 30 },
            });
          },
        });
    }
    else {
      if (
        accion == "firmar_notifica_aceptar" ||
        accion == "firmar_notifica_rechazar"
      ) {
        this.mostrarSpinnerMsg("Firmando y enviando documento...");

        this.servicioGeneral.findNotificacion(idTramite)
          .pipe(takeUntil(this.destroy$))
          .subscribe({
            next: (response: NotificaDetalles) => {
              let notificacion = response.envios;
              let destinatario: Destinatario =
                notificacion.destinatarios[0]?.notificaEnvio ??
                notificacion.titular;
              destinatario.aceptar = (accion == "firmar_notifica_aceptar");
              if (destinatario?.remesa?.tipoEnvio?.id && destinatario?.remesa?.tipoEnvio?.id == 3) {
                let idNextCloud: any = destinatario?.remesa?.justificante;
                this._download
                  .downloadB64(idNextCloud.id_gestor_documental)

                  .pipe(takeUntil(this.destroy$))
                  .subscribe({
                    next: (fichero) => {
                      this.servicioGeneral
                        .signNotificacionClave({
                          id: idTramite,
                          b64: fichero.Result,
                          csv: destinatario.csv,
                          aceptar: true
                        })

                        .pipe(takeUntil(this.destroy$))
                        .subscribe({
                          next: (data: any) => {
                            var continueTramite = data.canContinueRegister ?? true;
                            if (!continueTramite) {
                              if (data.message) {
                                this._notificationI18n.errorDynamic(data, 5000);
                              } else {
                                this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_ES_POSIBLE_FIRMAR_SOLICITUD_DNI_EXISTE', 5000);
                              }
                            }
                            //this.downloadPdf(data.b64Document, 'Justificante_'+destinatario.identificador);
                            this.ocultarSpinner();
                            this._router.navigate(["/perfil"], {
                              queryParams: { action: 33 },
                            });
                          },
                          error: (error) => {
                            console.error(error);
                            this.ocultarSpinner();
                            this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_FIRMAR_JUSTIFICANTE', 5000);
                            this._router.navigate(["/perfil"], {
                              queryParams: { action: 34 },
                            });
                          },
                        });
                    },
                  });
              } else {
                const pdfDocGenerator = pdfMake.createPdf(
                  this.pdfJustificante.objetPDF(destinatario)
                );

                //pdfDocGenerator.open()
                pdfDocGenerator.getBase64((data) => {
                  this.servicioGeneral
                    .generateCSVNotificacion({ base64: data })

                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                      next: (response) => {
                        destinatario.csv = response.CSV;

                        const pdfWithCSV = pdfMake.createPdf(
                          this.pdfJustificante.objetPDF(destinatario)
                        );
                        pdfWithCSV.getBase64((dataB64) => {
                          this.servicioGeneral
                            .signNotificacionClave({
                              id: idTramite,
                              b64: dataB64,
                              csv: destinatario.csv,
                              aceptar: destinatario.aceptar,
                            })

                            .pipe(takeUntil(this.destroy$))
                            .subscribe({
                              next: (data: any) => {
                                //this.downloadPdf(data.b64Document, 'Justificante_'+destinatario.identificador);
                                var continueTramite = data.canContinueRegister ?? true;
                                if (!continueTramite) {
                                  if (data.message) {
                                    this._notificationI18n.errorDynamic(data, 5000);
                                  } else {
                                    this._notificationI18n.error('NOTIFICATION.MESSAGE.NO_ES_POSIBLE_FIRMAR_SOLICITUD_DNI_EXISTE', 5000);
                                  }
                                }
                                this.ocultarSpinner();
                                this._router.navigate(["/perfil"], {
                                  queryParams: { action: 33 },
                                });
                              },
                              error: (error) => {
                                console.error(error);
                                this.ocultarSpinner();
                                this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_FIRMAR_JUSTIFICANTE', 5000);
                                this._router.navigate(["/perfil"], {
                                  queryParams: { action: 34 },
                                });
                              },
                            });
                        });
                      },
                      error: (error) => {
                        console.error(error);
                        this.ocultarSpinner();
                        this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_GENERAR_CSV_JUSTIFICANTE', 5000);
                        this._router.navigate(["/perfil"], {
                          queryParams: { action: 34 },
                        });
                      },
                    });
                });
              }
            },
            error: (error) => {
              console.error(error);
              this.ocultarSpinner();
              this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_NOTIFICACION_NO_ENCONTRADA', 5000);
              this._router.navigate(["/perfil"]);
            },
          });
      } else {
        this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_VALIDANDO_LOGIN_CLAVE', 5000);
        setTimeout(() => {
          this._router.navigate(["/perfil"]);
        }, 3000);
      }
    }
  }
  mostrarSpinnerMsg(mensaje: string) {
    this.mensajeSpinner = mensaje;
    this.spinner.show('firma_clave_spinner');
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide('firma_clave_spinner');
    }, 60000);
  }
  ocultarSpinner() {
    this.spinner.hide('firma_clave_spinner');
  }

  public downloadPdf(base64Document, fileName) {
    if (base64Document) {
      const source = "data:application/pdf;base64," + base64Document;
      const link = document.createElement("a");
      link.href = source;
      link.download = `${fileName}.pdf`;
      link.click();
    }
  }
  private firmaProcedimientoCustom(rId: string, idTramite: any) {
    let tramite: any = {
      IdTramite: idTramite,
      FirmarClave: true,
    };
    this.mostrarSpinnerMsg("Registrando el trámite...");
    this._solicituCustomService.updateEstadoTramite(tramite)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.downloadPdf(data.pdfFirmado, "comprobante_solicitud_tramite");
          this._router.navigate(["/perfil"], {
            queryParams: { action: 30 },
          });
          if (data.estadoFirma == 'FIRMADO_CON_REGISTRO' || data.estadoFirma == 'PENDIENTE_DE_FIRMA_AUTORIZADOS') {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_FINALIZADO_CON_EXITO', 5000);
          }
          else if (data.estadoFirma == 'PROCESANDO') {
            this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_PROCESANDO_CON_EXITO', 5000);
          }
          else {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_ACTUALIZANDO_ESTADO_TRAMITE_PANEL', 5000);
          }
          this.ocultarSpinner();
        },
        error: (error) => {
          this.ocultarSpinner();
          this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_ACTUALIZANDO_ESTADO_TRAMITE_PANEL', 5000);
          this._router.navigate(["/perfil"], {
            queryParams: { action: 30 },
          });
        },
      });
  }

  private deleteProcedimiento(rId: string, idTramite: any) {
    let tramite: TramiteEmvs = {
      id: +this.tramite.id,
      estadoFirma: EstadoTramite.FIRMADO_BAJA_USUARIO,
      estado: true,
      procedimiento_id: { id: this.procedimiento.id },
      firmarClave: true,
    };

    this._solicitudEmvsService.updateEstadoTramiteDelete(tramite)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {


          if (data.estadoFirma == 'FIRMADO_BAJA_USUARIO' && data.pdfFirmado) {
            this.downloadPdf(data.pdfFirmado, "comprobante_solicitud_tramite");
            this._notificationI18n.success('NOTIFICATION.MESSAGE.TRAMITE_ELIMINADO_CON_EXITO_PANEL', 5000);
          }
          else {
            this._notificationI18n.error(data?.pdfFirmado ? 'NOTIFICATION.MESSAGE.ERROR_ELIMINANDO_TRAMITE_PANEL' : 'NOTIFICATION.MESSAGE.ERROR_ELIMINANDO_TRAMITE_SIN_JUSTIFICANTE', 5000);
          }
          this._router.navigate(["/perfil"], {
            queryParams: { action: 30 },
          });

          this.ocultarSpinner();
        },
        error: (error) => {
          this.ocultarSpinner();
          if (error && error.error && error.error.responseError) {
            this._notificationI18n.errorDynamic(error.error, 5000);
          }
          else {
            this._notificationI18n.error('NOTIFICATION.MESSAGE.ERROR_ACTUALIZANDO_ESTADO_TRAMITE_PANEL', 5000);
          }
          this._router.navigate(["/perfil"], {
            queryParams: { action: 30 },
          });
        },
      });
  }
}
